import * as yup from 'yup';

export const verificationNameIssueValidationSchema = yup.object().shape({
	givenNames: yup.string().required('This field is required').min(1, 'This field is required'),
	familyNames: yup.string().required('This field is required').min(1, 'This field is required'),
});
